<template>
  <div class="recordGridPanel">
    <el-table
      :data="source"
      :height="tabHeight"
      ref="multipleTable"
      @current-change="handleCurrentChange"
      @selection-change="handleSelectionChange"
      @select="select"
      @select-all="selectAll"
      @row-contextmenu="rowContextmenu"
      highlight-current-row
      style="width: 100%"
    >
      <el-table-column type="selection" v-show="multiSelected" width="55"></el-table-column>
      <el-table-column prop="INSTANCE" label="编号" width="80"></el-table-column>
      <el-table-column prop="CREATEUSERNAME" label="创建人" width="80"></el-table-column>
      <el-table-column label="创建时间" width="180">
        <template slot-scope="scope">
          {{
          scope.row.CREATETIME | timeFormater
          }}
        </template>
      </el-table-column>
      <el-table-column label="记录类型" width="110">
        <template slot-scope="scope">
          <el-tag
            effect="plain"
            :type="scope.row.RECORDTYPE === 0 ? 'info' : 'success'"
          >{{ scope.row.RECORDTYPE|recordTypeNameFormat}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="记录名称">
        <template slot-scope="scope">
          <el-link
            type="primary"
            @click.native="showRecordDetail(scope.row.ID)"
            :underline="false"
          >{{ scope.row.NAME }}</el-link>
        </template>
      </el-table-column>

      <el-table-column label="关联任务">
        <template slot-scope="scope">
          <div style="display:flex;flex-wrap: wrap;">
            <el-link
              type="primary"
              style="margin-right:10px"
              v-for="(item,index) in scope.row.Relations"
              :key="index"
              @click.native="showTaskDetail(item.RELATIONID)"
              :underline="false"
            >{{ item.RELATIONNAME }}</el-link>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <CreateItem ref="createControl" @getValue="successed"></CreateItem>
     <!-- 
      @name contextMenu
      @desc 右键菜单
      @param contextMenu table 选中行
    -->
    <contextmenuRecord ref="contextmenuRecord" @successed="successed" :contextMenu="contextmenuRow" :isTask="false"></contextmenuRecord>

   
  </div>
</template>

<script>
import CreateItem from "../components/CreateItem.vue";
import Sortable from "sortablejs";
export default {

  components: {
    CreateItem,
    contextmenuRecord: () => import("@/views/task/common/contextmenuRecord.vue"), //右键菜单
  },
  props: {
    multiSelected: {
      type: Boolean,
      default: false,
    },
    source: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      filedID: "ID",
      contextmenuRow:{},//右键当前行
      multipleSelection: [],
      tabHeight: ($(window).height() - 150).toString(),
      currentRow: {},
      contextMenuData: {
        menuName: "taskList",
        axis: {
          x: null,
          y: null,
        },
        data: null,
        menulists: [
          {
            fnHandler: "createdTask",
            icoName: "fa fa-commenting fa-fw",
            btnName: "生成任务",
          },
        ],
      },
    };
  },
  filters: {
    recordTypeNameFormat(val) {
      switch (val) {
        case 1:
          return "问询";
        case 2:
          return "代办事项";
        case 3:
          return "催办";
        case 4:
          return "提醒";
        case 5:
          return "会议记录";
        case 0:
        default:
          return "工作日志";
      }
    },
  },
  methods: {
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const _this = this;
      Sortable.create(tbody, {
        pull: "clone",
        sort: false,
        onStart: function ({ newIndex, oldIndex }) {
          const currRow = _this.source[oldIndex]; //.splice(oldIndex, 1)[0];
          _this.setDragRow(currRow);
        },
      });
    },
    successed() {
      this.$emit("successed");
    },
    handleCurrentChange(val) {
      this.currentRow = val;
    },
    clearSelection() {
      this.$refs.multipleTable.clearSelection();
    },
    //多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getValue() {
      return this.multipleSelection;
    },
    select(selection, row) {
      let index = selection.indexOf(row);
      if (index > -1) {
        this.$emit("select", row, true);
      } else {
        this.$emit("select", row, false);
      }
    },
    selectAll(selection) {
      this.$emit("select-all", selection);
    },
    toggleRowSelection(row, isSelect) {
      this.$refs.multipleTable.toggleRowSelection(row, isSelect);
    },
    clearSelection() {
      this.$refs.multipleTable.clearSelection();
    },
    createdTask() {
      this.$refs.createControl.createTaskMeg.taskName = this.currentRow.NAME;
      this.$refs.createControl.createTaskMeg.content = this.currentRow.CONTENT;
      this.$refs.createControl.dialogVisible = true;
    },
    showTaskDetail(taskid) {
      let routeUrl = `${location.href.substr(
        0,
        location.href.lastIndexOf("/")
      )}/task-detailspage?taskid=${taskid}`;
      console.log(routeUrl);
      window.open(routeUrl, "_blank");
    },
    showRecordDetail(recordid) {
      let routeUrl = `${location.href.substr(
        0,
        location.href.lastIndexOf("/")
      )}/recordinfo?recordid=${recordid}`;
      console.log(routeUrl);
      window.open(routeUrl, "_blank");
    },
    /**
     * 右键工作记录菜单
     */
    rowContextmenu(row, column, event) {
      console.log(row);
    
      event.preventDefault();
      this.contextmenuRow = row;
      const postition = {
        top: event.clientY,
        left: event.clientX,
      };

      this.$refs.contextmenuRecord.Show(postition);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.rowDrop();
    });
  },
};
</script>

<style lang="scss" scoped></style>
